module.exports = __webpack_public_path__ + "img/past-exam-questions.afac9985.svg";